"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
var _gradeHistory = require("@/api/log/gradeHistory");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'gradeHistory',
  data: function data() {
    return {
      loading: false,
      searchForm: {
        cardNo: '',
        status: null,
        page: 1,
        limit: 10,
        total: 0
      },
      tableData: []
    };
  },
  methods: {
    fetchList: function fetchList() {
      var _this = this;
      this.loading = true;
      (0, _gradeHistory.getVipGradeHistoryList)(this.searchForm).then(function (res) {
        _this.tableData = res.records || [];
        _this.searchForm.total = res.total || 0;
      }).finally(function () {
        _this.loading = false;
      });
    },
    resetForm: function resetForm() {
      this.searchForm = {
        cardNo: '',
        status: null,
        page: 1,
        limit: 10,
        total: 0
      };
      this.fetchList();
    },
    handleSizeChange: function handleSizeChange(size) {
      this.searchForm.limit = size;
      this.searchForm.page = 1;
      this.fetchList();
    },
    handlePageChange: function handlePageChange(page) {
      this.searchForm.page = page;
      this.fetchList();
    },
    getStatusText: function getStatusText(status) {
      var statusMap = {
        0: '未领取',
        1: '领取中',
        2: '已领取'
      };
      return statusMap[status] || '未知状态';
    },
    getStatusType: function getStatusType(status) {
      var typeMap = {
        0: 'info',
        1: 'warning',
        2: 'success'
      };
      return typeMap[status] || '';
    },
    formatTimestamp: function formatTimestamp(ts) {
      if (!ts) return '-';
      var time = Number(ts);
      if (isNaN(time)) return '-';
      var date = new Date(time);
      return date.toLocaleString();
    }
  },
  mounted: function mounted() {
    this.fetchList();
  }
};